<template>
    <input type="text" v-model="state" :name="'textinput-'+uid" :id="'textinput-'+uid" class="form-control ajax-textinput"
            v-bind:class="{'vuecrud-ajax-select-loading': loading, 'vuecrud-ajax-select-dirty': savedState != state}"
    >
</template>

<script>
    export default {
        props: {
            subject: {type: Object},
            url: {type: String},
            action: {type: String},
            value: {},
            labelContent: {type: String, default: ''},
            componentId: {},
        },
        data: function() {
            return {
                state: -1,
                initialized: false,
                loading: false,
                uid: Math.ceil(Math.random() * 10000000000000),
                savedState: '',
                timer: 0,
            }
        },
        mounted() {
            this.state = this.value;
            this.savedState = this.state;
            if (!this.initialized) {
                this.initialized = true;
                let inputElement = this;
                this.$watch('state', function() {
                    window.clearTimeout(this.timer);
                    this.timer = window.setTimeout(() => {
                        inputElement.loading = true;
                        inputElement.savedState = this.state;
                        window.axios.post(this.url, {
                            action: inputElement.action,
                            subject: inputElement.subject,
                            state: inputElement.state,
                            componentId: inputElement.componentId
                        }).then((response) => {
                            inputElement.$emit('input', inputElement.state);
                            inputElement.loading = false;
                        }).catch((error) => {
                            console.log(error.response);
                            inputElement.loading = false;
                            alert(error.response.data);
                        });
                    }, 1000);
                });
            }
        },
        computed: {}
    }
</script>
<style>
    .vuecrud-ajax-select-loading {
        opacity: .2;
    }
</style>
